<h2>Checklist</h2>

<!-- <div class="mb-6">
  <ui-alert
    color="secondary"
    icon="griddy-magic-wand"
    title="Auto-generate checklist"
    message="Add over 10 tasks used by 90% of hosts with similar properties."
    [action]="alertAction()"
    [hideCloseButton]="true" />
</div> -->

<ui-checklist-builder [(checklist)]="checklist" />
